module.exports = __webpack_public_path__ + "static/media/A1_bg.52df76c6.png";